import { ALERT_SET_ACTION, ALERT_ACTION, SET_SPINNER } from './action-types'
import { alert, type AlertSeverity } from '../../components/Alert/Alert'

export function onShowAlert(message: string, flg: string) {
  return async (dispatch: any) => {
    dispatch({
      type: ALERT_SET_ACTION,
      payload: {
        msg: message,
        flg: flg,
      },
    })
    // The `utilesModule.alert` slice this dispatch writes has NO consumer — no
    // component ever rendered it, so every onShowAlert() in the app (server
    // rejections included) died silently. Route the message to the global
    // AlertHost dialog so the player actually sees it.
    //
    // `flg` carries the severity every caller already passes ('error' | 'warning' | 'success' |
    // 'info'); forward it so a failure is not styled identically to a confirmation.
    void alert.open(message, { severity: flg as AlertSeverity })
  }
}

export function handleAlert() {
  return async (dispatch: any) => {
    dispatch({
      type: ALERT_ACTION,
    })
  }
}

export function handleSpinner(flag: boolean, content: string) {
  return async (dispatch: any) => {
    dispatch({
      type: SET_SPINNER,
      payload: {
        flag,
        content,
      },
    })
  }
}
